"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = require("styled-components");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Theme
const BaseInput = (0, _styledComponents.css)(["box-sizing:border-box;background:", ";border-style:solid;border-width:1px;border-color:rgb(204,204,204);border-radius:", ";color:", ";font-family:", ";font-size:", ";line-height:", ";margin:0;padding:9px ", " ", ";transition:all 100ms ease 0s;width:100%;&::placeholder{color:", ";font-style:italic;}&:hover{outline:0;border-color:", ";}&:focus{}&:disabled{background-color:", ";&:hover{outline:0;border-color:rgb(204,204,204);}}"], _BaseTheme.default.colors.white, _BaseTheme.default.radius.regular, _BaseTheme.default.colors.gray, _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.normal, _BaseTheme.default.type.lineHeight.regular, _BaseTheme.default.distance.small, _BaseTheme.default.distance.small, _BaseTheme.default.colors.lightgray, _BaseTheme.default.colors.blue, _BaseTheme.default.colors.inputDisabledGray);
var _default = BaseInput;
exports.default = _default;